import { render } from "./columnarDetails.vue?vue&type=template&id=7432db7c&scoped=true"
import script from "./columnarDetails.vue?vue&type=script&lang=js"
export * from "./columnarDetails.vue?vue&type=script&lang=js"

import "./columnarDetails.vue?vue&type=style&index=0&id=7432db7c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7432db7c"]])

export default __exports__